import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FavoritePharmacyDataList {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  FavoritePharmacyDataListData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: FavoritePharmacyDataList = {
  isLoading: false,
  error: false,
  message: null,
  FavoritePharmacyDataListData: [],
  Items: [],
  Pagination: [],
};

const FavoritePharmacyDataListSlice = createSlice({
  name: "favoritePharmacydataList",
  initialState,
  reducers: {
    loadingFavoritePharmacyDataList: (
      state: FavoritePharmacyDataList,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setFavoritePharmacyDataList: (
      state: any,
      action: PayloadAction<FavoritePharmacyDataList>
    ) => {
      return action.payload;
    },
    clearData: (state: FavoritePharmacyDataList, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const {
  loadingFavoritePharmacyDataList,
  setFavoritePharmacyDataList,
  clearData,
} = FavoritePharmacyDataListSlice.actions;

export default FavoritePharmacyDataListSlice.reducer;
